import { en } from "./en";
import { ar } from "./ar";

export const text = { en, ar };
export { en, ar };
